<!--
  --
  -- 予約系のサブヘッダ
  --
  -->
<template>
  <h2 class="text-subtitle-1 mb-3"><slot/></h2>
</template>

<script>
export default {
  name: 'CBookSubheader'
}
</script>
